import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'
class TableRow extends Component {
  render () {
    return (
      <div className={'TableRow ' + (this.props.className ? this.props.className : '')}>
        {this.props.children}
      </div>
    )
  }
}
TableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired
}
export default TableRow
